import React, { useState } from "react";
import { v4 } from "uuid";

import {
  Button,
  Dialog,
  Card,
  CardBody,
  CardFooter,
  Typography,
} from "@material-tailwind/react";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { imageDb } from "../../../firebase";
import { updateUserProfile } from "store/services/Profile/profile";
import { useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";

const ImageModal = ({
  isOpen,
  handleModalToggle,
  modalData,
  checkProfileUpdate,
}) => {
  const { user } = useSelector((store) => store.userReducer);
  const { selectedStore } = useSelector((store) => store.selectedStore);

  const [image, setImage] = useState("");
  const [imagePrev, setImagePrev] = useState("");
  const [loading, setLoading] = useState(false);

  const changeImage = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setImagePrev(reader.result);
      setImage(file);
    };
  };
  const closeHandler = () => {
    handleModalToggle();
    setImagePrev("");
    setImage("");
  };
  const handleChangeImage = async () => {
    try {
      checkProfileUpdate();

      setLoading(true);
      const imgRef = ref(imageDb, `/images/${v4()}`);
      await uploadBytes(imgRef, image);
      const imageCompleteURL = await getDownloadURL(imgRef);
      if (imageCompleteURL) {
        const result = await updateUserProfile(user.accessToken, user.data.id, {
          photo_url: imageCompleteURL,
          first_name: modalData?.formData.first_name.trim(),
          last_name: modalData?.formData.last_name.trim(),
          phone_number: modalData?.phone.trim(),
          location: modalData?.formData.location.trim(),
           postcode: modalData?.formData.postcode.trim(),
        });
        if (result.success) {
          checkProfileUpdate(true);
          closeHandler();
          setLoading(false);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      size="xs"
      open={isOpen}
      handler={handleModalToggle}
      className="bg-transparent shadow-none"
    >
      <Card className="mx-auto w-full max-w-[24rem]">
        <CardBody className="flex flex-col gap-4">
          <Typography variant="h4" color="blue-gray">
            {modalData.title}
          </Typography>
          {imagePrev && (
            <img
              className="object-cover object-center ml-auto mr-auto rounded-full h-44 w-44"
              src={imagePrev}
              alt="profilePic"
            />
          )}
          <label className="inline-block px-2 py-1 text-sm font-bold text-center text-white bg-yellow-800 rounded-lg cursor-pointer">
            <input type="file" className="hidden" onChange={changeImage} />
            CHOOSE FILE
          </label>

          <button
            style={{
              backgroundColor:
                image === ""
                  ? "lighterGray"
                  : selectedStore?.theme.backgroundColor,
            }}
            disabled={image === "" ? true : false}
            className={
              image === ""
                ? ` px-1 py-1 text-sm font-bold text-white rounded-lg  bg-gray-400`
                : `px-1 py-1 text-sm font-bold text-white rounded-lg bg-theme-color `
            }
            onClick={handleChangeImage}
          >
            {loading ? <ClipLoader size={20} /> : modalData.purpleButton}
          </button>
        </CardBody>
        <CardFooter className="flex justify-end gap-3 pt-0 ">
          <Button className="px-2 py-2 bg-red-800" onClick={closeHandler}>
            {modalData.redButton}
          </Button>
        </CardFooter>
      </Card>
    </Dialog>
  );
};

export default ImageModal;
